import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, TextField } from 'office-ui-fabric-react';
import { resolveValidationRules } from '../../../../../../utilities/validationRuleHelper';

const dropdownStylesHalf = {
  root: { width: '50%', padding: '7px 0' },
  label: {
    fontSize: '14',
    fontWeight: '500',
    color: '#333333',
  },
};

const TitleFieldWrite = ({
  templateOptions,
  titleValue,
  onChange,
  validationEntity,
}) => {
  const { t: translator } = useTranslation();

  const { maxLength } = resolveValidationRules(validationEntity);

  const onChangeDropDown = (_, value) =>
    onChangeText(_, (value?.content ? value.content : value.text) || '');

  const onChangeText = (_, value) =>
    onChange(value && value.substring(0, maxLength));

  return (
    <div
      className="create-hearing-form-field"
      aria-label={translator('ariaLabel.titleFieldWrite')}
    >
      <Dropdown
        placeholder={translator('global.noneSelected')}
        label={translator('pages.createHearing.titleLabel')}
        onChange={onChangeDropDown}
        options={templateOptions}
        styles={dropdownStylesHalf}
        disabled={templateOptions.length === 0}
      />
      <TextField
        id="contact-person-name"
        placeholder={translator('hearingProperties.title')}
        onChange={onChangeText}
        value={titleValue}
      />
      <div>
        <p className="field-limit-char-count">
          {translator('global.noOfChars')} {titleValue ? titleValue.length : 0}/
          {maxLength}
        </p>
      </div>
    </div>
  );
};

export { TitleFieldWrite };
